import { TemplateRef } from '@angular/core';
import { UserService } from '../../../services/user.service';
import { MatDialog } from '@angular/material';
import { Validators, FormBuilder, FormControl } from '@angular/forms';
import { RutValidator } from 'ng2-rut';
import { FormService } from 'src/app/services/form.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { startWith, map } from 'rxjs/operators';
var PropietarioComponent = /** @class */ (function () {
    function PropietarioComponent(fb, _userService, rutValidator, dialog, spinner) {
        this.fb = fb;
        this._userService = _userService;
        this.rutValidator = rutValidator;
        this.dialog = dialog;
        this.spinner = spinner;
        this.rows = [];
        this.matcher = new FormService();
        this.nombreComuna = new FormControl('', [Validators.required]);
        this.options = [];
        this.selectedPro = null;
        this.regexp = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
        this.rut_pro = this.fb.group({
            rut: ['', [Validators.required, this.rutValidator]]
        });
        this.mail_pro = this.fb.group({
            mail: ['', [Validators.pattern(this.regexp), Validators.required, Validators.maxLength(50)]]
        });
        if (!JSON.parse(localStorage.getItem("propietarios"))) {
            localStorage.setItem("propietarios", JSON.stringify(this.rows));
        }
        else {
            this.rows = JSON.parse(localStorage.getItem("propietarios"));
        }
        this.invalidRut = true;
        this.propietario = { rut: '', nombre: '', apellido_mat: '', apellido_pat: '', nombre_completo: '', direccion: '', direccion_num: '', direccion_complemento: '', direccion_completa: '', comuna: '', fono: '', fax: '', mail: '', recordId: '' };
    }
    PropietarioComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.getComunas();
        this.filteredOptions = this.nombreComuna.valueChanges
            .pipe(startWith(''), map(function (value) { return _this._filter(value); }));
    };
    PropietarioComponent.prototype._filter = function (value) {
        var filterValue = ('' + value).toLowerCase();
        return this.options.filter(function (option) { return ('' + option).toLowerCase().includes(filterValue); });
    };
    PropietarioComponent.prototype.get_propietario = function (rut, soloVer) {
        var _this = this;
        this.propietario.nombre_completo = this.propietario.nombre.toString() + " " + this.propietario.apellido_pat.toString() + " " + this.propietario.apellido_mat.toString();
        //console.log(this.propietario.nombre_completo)
        window.scroll(0, 0);
        this.spinner.show();
        this.cleanData();
        this._userService.getPropietario(rut).subscribe(function (response) {
            //console.log('get propietarios response', response)
            if (response.message) {
                _this.propietario.rut = rut ? rut : '';
                _this.spinner.hide();
                _this.dialog.open(_this.openModal);
            }
            else {
                _this.propietario.rut = response.rut ? response.rut : '';
                _this.propietario.nombre = response.nombre ? response.nombre : '';
                _this.propietario.apellido_mat = response.apellido_mat ? response.apellido_mat : '';
                _this.propietario.apellido_pat = response.apellido_pat ? response.apellido_pat : '';
                _this.propietario.nombre_completo = response.nombre_completo ? response.nombre_completo : '';
                _this.propietario.direccion = response.direccion ? response.direccion : '';
                _this.propietario.direccion_num = response.direccion_num ? response.direccion_num : '';
                _this.propietario.direccion_complemento = response.direccion_complemento ? response.direccion_complemento : '';
                _this.propietario.direccion_completa = response.direccion_completa ? response.direccion_completa : '';
                _this.propietario.comuna = response.comuna ? response.comuna : '';
                _this.propietario.fono = response.fono ? response.fono : '';
                _this.propietario.fax = response.fax ? response.fax : '';
                _this.propietario.mail = response.mail ? response.mail : '';
                _this.propietario.recordId = response.recordId ? response.recordId : '';
                if (soloVer) {
                    _this.spinner.hide();
                    _this.dialog.open(_this.openModalVer);
                }
                else {
                    _this.spinner.hide();
                    _this.dialog.open(_this.openModal);
                }
            }
        }, function (error) {
            console.log(error);
            _this.spinner.hide();
        });
    };
    PropietarioComponent.prototype.cleanData = function () {
        this.propietario = { rut: '', nombre: '', apellido_mat: '', apellido_pat: '', nombre_completo: '', direccion: '', direccion_num: '', direccion_complemento: '', direccion_completa: '', comuna: '', fono: '', fax: '', mail: '', recordId: '' };
        this.rut_pro.reset();
    };
    PropietarioComponent.prototype.update_propietario = function (rut, id) {
        this.get_propietario(rut);
        this.selectedPro = id;
        //console.log('update_propietario this.selectedPro', this.selectedPro);
    };
    PropietarioComponent.prototype.savePropietario = function () {
        var _this = this;
        this.propietario.nombre_completo = this.propietario.nombre.toString() + " " + this.propietario.apellido_pat.toString() + " " + this.propietario.apellido_mat.toString();
        //console.log(this.propietario.nombre_completo)
        window.scroll(0, 0);
        //por si escriben un rut que ya esté ingresado
        for (var x = 0; x < this.rows.length; x++) {
            if (this.propietario.rut == this.rows[x].rut) {
                this.delete_propietario(x);
                //console.log("deleting rut:" + this.propietario.rut + "index: " + x)
            }
        }
        //elimina fila cuando la editan
        /*if (this.selectedPro != null) {
            this.delete_propietario(this.selectedPro);
            console.log("deleting rut:" + this.propietario.rut + ' this.selectedPro ' + this.selectedPro)
            this.selectedPro = null;
        }*/
        //console.log('savePropietario this.propietario', this.propietario)
        this.spinner.show();
        this._userService.savePropietario(this.propietario).subscribe(function (response) {
            _this.spinner.hide();
            //console.log("save propietario component ts response", response)
            if (response.update || response.save) {
                $("#prop_modal").modal("hide");
                _this.actualRow = localStorage.getItem("propietarios");
                _this.rows = JSON.parse(_this.actualRow);
                _this.rows = _this.rows.concat({
                    rut: _this.propietario.rut,
                    nombre: _this.propietario.nombre,
                    apellido_pat: _this.propietario.apellido_pat,
                    apellido_mat: _this.propietario.apellido_mat,
                    nombre_completo: _this.propietario.nombre_completo,
                    direccion: _this.propietario.direccion,
                    direccion_num: _this.propietario.direccion_num,
                    direccion_complemento: _this.propietario.direccion_complemento,
                    direccion_completa: _this.propietario.direccion_completa,
                    comuna: _this.propietario.comuna,
                    fono: _this.propietario.fono,
                    fax: _this.propietario.fax,
                    mail: _this.propietario.mail,
                    recordId: _this.propietario.recordId
                });
                //console.log('this.rows', this.rows)
                localStorage.setItem("propietarios", JSON.stringify(_this.rows));
                _this.propietario = { rut: '', nombre: '', apellido_mat: '', apellido_pat: '', direccion: '', direccion_num: '', direccion_complemento: '', direccion_completa: '', comuna: '', fono: '', fax: '', mail: '', recordId: '' };
                _this.rut_pro.reset();
                _this.dialog.closeAll();
            }
        }, function (error) {
            console.log(error);
            _this.spinner.hide();
        });
    };
    PropietarioComponent.prototype.delete_propietario = function (id) {
        for (var x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("propietarios", JSON.stringify(this.rows));
                //console.log('delete_propietarios1 this.rows', this.rows)
                this.rows = JSON.parse(localStorage.getItem('propietarios'));
                //console.log('delete_propietarios2 this.rows', this.rows)
            }
        }
    };
    PropietarioComponent.prototype.getComunas = function () {
        var _this = this;
        this._userService.getComunas().subscribe(function (res) {
            //console.log('res', res);
            for (var i = 0; i < res.length; i++) {
                _this.options.push(res[i].fieldData.COM_Nombre);
            }
            _this.filteredOptions = _this.nombreComuna.valueChanges
                .pipe(startWith(''), map(function (value) { return _this._filter(value); }));
        }, function (error) {
            console.log(error);
        });
    };
    return PropietarioComponent;
}());
export { PropietarioComponent };
